import { CategoriesApiRemoteService } from '../../Services/api/categories/categories-service'
import { IUpdateCategoryPayload } from '../../Services/api/categories/categories.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateCategoriesUseCase
implements IFormUsecase<IUpdateCategoryPayload, void> {
  constructor (private readonly CategoriesApi: CategoriesApiRemoteService) {}
    

  public async handle (
    data: IUpdateCategoryPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CategoriesApi.update(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
